import BlockSingleProperty from '@/components/blocks/Properties/BlockSingleProperty';
import BlockCommercial from '@/components/blocks/Properties/BlockCommercial';
import BlockPropertyHistory from '@/components/blocks/Properties/BlockPropertyHistory';
import SuperOrAgent from '@/services/RouteGuards/SuperOrAgent';

export default [
	{
		path: 'properties/single/:id',
		name: 'SinglePropertyAgent',
		component: BlockSingleProperty,
		props: {
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Property - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperOrAgent
	},
	{
		path: 'commercial',
		name: 'Commercial',
		component: BlockCommercial,
		props: {
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Commercials - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperOrAgent
	},
	{
		path: 'properties/history/:id',
		name: 'PropertyHistoryAgent',
		component: BlockPropertyHistory,
		props: {
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Property history - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperOrAgent
	}
];
